import React from "react";
import { Flex } from "@chakra-ui/react";
import { ContasRelatorioReceitas } from "features/relatorios/typings";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";

interface TableItemRowProps {
  conta: ContasRelatorioReceitas;
}
function TableItemRow({ conta }: TableItemRowProps) {
  return (
    <>
      <Flex flex={1.5}>
        <Flex ml={8}>{conta.descricao ? conta.descricao : "--"}</Flex>
      </Flex>

      <Flex flex={1} justifyContent="flex-end">
        {conta.createdAt ? moment(conta.createdAt).format("DD/MM/YYYY") : "--"}
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        {conta.dataVencimento
          ? moment(conta.dataVencimento).format("DD/MM/YYYY")
          : "--"}
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        {conta.dataPagamento
          ? moment(conta.dataPagamento).format("DD/MM/YYYY")
          : "--"}
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        {conta.dataMovimentacao
          ? moment(conta.dataMovimentacao).format("DD/MM/YYYY")
          : "--"}
      </Flex>
      <Flex flex={1} justifyContent="flex-end" textAlign="end">
        {conta.centroDeCusto ? conta.centroDeCusto.nome : "--"}
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        {conta.nossoNumero ?? "--"}
      </Flex>

      <Flex flex={1} justifyContent="flex-end">
        {conta.valor ? formatMoney(conta.valor) : "--"}
      </Flex>
    </>
  );
}

export default TableItemRow;
